import createIcon from '@/lib/create-icon'

const NftIcon = createIcon(
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'>
    <path
      d='M9.6248 1.83325C6.17943 1.83325 4.45675 1.83325 3.30663 3.02539C3.12268 3.21606 2.95255 3.42623 2.7982 3.65346C1.83313 5.07419 1.83313 7.20222 1.83313 11.4583C1.83313 15.7143 1.83313 17.8423 2.7982 19.263C2.95255 19.4903 3.12268 19.7004 3.30663 19.8911C4.45675 21.0833 6.17943 21.0833 9.6248 21.0833H12.3748C15.8202 21.0833 17.5429 21.0833 18.6929 19.8911C18.8769 19.7004 19.047 19.4903 19.2014 19.263C20.1665 17.8423 20.1665 15.7143 20.1665 11.4583C20.1665 7.20222 20.1665 5.07419 19.2014 3.65346C19.047 3.42623 18.8769 3.21606 18.6929 3.02539'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.16687 16.5H10.5419'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.8333 0.916748L13.1861 2.48269C13.4853 3.81085 14.5225 4.84815 15.8507 5.14735L17.4167 5.50008L15.8507 5.85281C14.5225 6.15201 13.4853 7.18922 13.1861 8.51747L12.8333 10.0834L12.4806 8.51747C12.1814 7.18922 11.1441 6.15201 9.81591 5.85281L8.25 5.50008L9.81591 5.14735C11.1441 4.84815 12.1814 3.81094 12.4806 2.48269L12.8333 0.916748Z'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinejoin='round'
    />
    <path
      d='M13.2919 16.5H16.5002'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>,
  'NftIcon'
)

export default NftIcon
